//Reducer for loading filter data options
import moment from 'moment';
const partsFiltersDataReducerDefaultState = {
    minDate       : moment.utc().subtract(1 ,'month').format('YYYY-MM-DD'),
    maxDate       : moment.utc().format('YYYY-MM-DD'),
    isLoaded      : false,
    isErrorsParts : false
};

export default (state = partsFiltersDataReducerDefaultState, action) => {
    switch(action.type) {
        case 'SET_IS_LOADED_PARTS':
            return {
                ...state,
                isLoaded : action.isLoaded
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/Reducers/partsFlitersData.js